var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.826,
    height: 33.873,
    viewBox: "0 0 33.826 33.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_icons",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M28.748,14.775c-.188-.188-.188-.376-.376-.565L22.726,8.565A1.863,1.863,0,0,0,20.092,11.2l2.446,2.446H13.882A1.778,1.778,0,0,0,12,15.527a1.778,1.778,0,0,0,1.882,1.882h8.656l-2.446,2.446a1.819,1.819,0,0,0,0,2.635,1.819,1.819,0,0,0,2.635,0l5.646-5.646c.188-.188.376-.376.376-.565A2.078,2.078,0,0,0,28.748,14.775Z",
    transform: "translate(4.937 1.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M26.523,31.416a13.731,13.731,0,0,1-6.586,1.694,13.173,13.173,0,0,1,0-26.346,13.731,13.731,0,0,1,6.586,1.694A1.937,1.937,0,0,0,28.4,5.07,18.761,18.761,0,0,0,19.937,3a16.937,16.937,0,0,0,0,33.873A16.792,16.792,0,0,0,28.4,34.615a2.084,2.084,0,0,0,.753-2.635A2.026,2.026,0,0,0,26.523,31.416Z",
    transform: "translate(-3 -3)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/_icons.4705b112117618122b17146a61f941c8.svg";
export { ForwardRef as ReactComponent };